/**
 * @generated SignedSource<<82919585bdc1593c1eeeea092405c769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EnrollDateDialog_program$data = {
  readonly id: string;
  readonly " $fragmentType": "EnrollDateDialog_program";
};
export type EnrollDateDialog_program$key = {
  readonly " $data"?: EnrollDateDialog_program$data;
  readonly " $fragmentSpreads": FragmentRefs<"EnrollDateDialog_program">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EnrollDateDialog_program",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Program",
  "abstractKey": null
};

(node as any).hash = "8efb36246f7c92edf744caa89e0e2439";

export default node;
